export default __webpack_public_path__ + "static/media/developer-dark.3f07bd13.svg";